import { Box, useTheme } from '@ltvco/refresh-lib/theme';

export function SuggestionsMessage({ suggestions }: { suggestions: string[] }) {
  const theme = useTheme();
  if (!suggestions || suggestions.length === 0) {
    return null;
  }
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        borderRadius: '8px',
        padding: '16px',
        gap: '10px',
      }}
    >
      <Box sx={{ fontWeight: 500, fontSize: 14 }}>
        You can also add more details to narrow your search:
      </Box>
      <ul>
        {suggestions.map((s) => (
          <li key={s} style={{ fontSize: 14, marginBottom: 4 }}>
            {s}
          </li>
        ))}
      </ul>
    </Box>
  );
}
